import React, { useState } from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import styled from 'styled-components'
import { Event as EventModel } from '../../model/Event'
import {EmptyEvent as EventModelEmpty} from '../../model/Event/EmptyEvent'
import { useConfigContext } from '../App/App'
import Event from './Event/Event'
import ProgressBar from './ProgressBar/ProgressBar'

const Wrapper = styled.div`
  display: flex;
  flex: 1;
`

const Transition = styled(TransitionGroup)`
  width: 100%;
  display: flex;
  flex-direction: column;
  color: #383838;
  margin: -1rem 0;
`

interface IProps {
  readonly events: EventModel[]
}

const Router = ({ events }: IProps) => {
  const { device, routerMin, routerScroll, nextScroll } = useConfigContext()
  const isPortraitOriented = window.innerHeight > window.innerWidth
  const linesPerPage = isPortraitOriented ? 6 : 5

  const routerEvents = events.filter((event: EventModel) => event.hasRoute())
  const applyRouterReservation = device.router && routerEvents.length > 0
  let linesForRouter = applyRouterReservation ? routerMin : 0
  const routerPageCount = Math.ceil(routerEvents.length / linesForRouter)
  const [routerOffset, changeRouterOffset] = useState(0)
  let visibleRouterEvents = routerEvents
    .filter((event: EventModel, index) => index >= routerOffset && index < (routerOffset + linesForRouter))

  const currentEvents = events.filter((event: EventModel) => event.isOngoing() && !event.hasRoute())
  const linesForCurrent = linesPerPage - linesForRouter
  const currentPageCount = Math.ceil(currentEvents.length / linesForCurrent)
  const [currentOffset, changeCurrentOffset] = useState(0)
  const visibleCurrentEvents = currentEvents
    .filter((event: EventModel, index) => index >= currentOffset && index < (currentOffset + linesForCurrent))

  const nextEvents = events.filter((event: EventModel) => !event.isOngoing() && !event.hasRoute())
  const linesForNext = linesPerPage - visibleCurrentEvents.length - (applyRouterReservation ? visibleRouterEvents.length : 0)
  const nextPageCount = Math.ceil(nextEvents.length / linesForNext)
  const [nextOffset, changeNextOffset] = useState(0)
  const visibleNextEvents = nextEvents
    .filter((event: EventModel, index) => index >= nextOffset && index < (nextOffset + linesForNext))

  linesForRouter = linesPerPage - visibleCurrentEvents.length - visibleNextEvents.length
  visibleRouterEvents = routerEvents
    .filter((event: EventModel, index) => index >= routerOffset && index < (routerOffset + linesForRouter))

  const showProgressBar = currentPageCount > 1 || (routerScroll && routerPageCount > 1) || (nextScroll && nextPageCount > 1)

  const rotate = () => {
    changeCurrentOffset(currentOffset + linesForCurrent >= currentEvents.length ? 0 : currentOffset + linesForCurrent)

    if (routerScroll) {
      changeRouterOffset(routerOffset + linesForRouter >= routerEvents.length ? 0 : routerOffset + linesForRouter)
    }

    if (nextScroll) {
      changeNextOffset(nextOffset + linesForNext >= nextEvents.length ? 0 : nextOffset + linesForNext)
    }
  }

  const visibleEvents = [...visibleCurrentEvents, ...visibleNextEvents, ...visibleRouterEvents]

  // Add empty events, it cause no stretching
  const length = visibleEvents.length
  for (let i = 0; i < linesPerPage - length; i++) {
    visibleEvents.push(new EventModelEmpty())
  }

  return (
    <Wrapper>
      {showProgressBar && <ProgressBar
        routerOffset={routerOffset}
        currentOffset={currentOffset}
        nextOffset={nextOffset}
        onProgressEnd={rotate}
      />}
      <Transition>
      {visibleEvents.map((event: EventModel) => (
        <CSSTransition key={event.key} classNames="event" timeout={{ enter: 1000 }} mountOnEnter={true} unmountOnExit={true} exit={false}>
          <Event event={event} isPortraitOriented={isPortraitOriented}/>
        </CSSTransition>
      ))}
      </Transition>
    </Wrapper>
  )
}

export default Router
